<template>
  <div :class="classes">
    <span :class="pouce_up" @click="submit(1)">thumb_up</span>
    <span :class="pouce_down" @click="submit(-1)">thumb_down</span>
  </div>
</template>

<script>
    const store_utils = require("@/store_utils").default;
    import { customLogger } from "@/utils";
    export default {
        name: 'MessageChecker',
        data() {
            return {
                user_id: this.$store.state.user.id,
                classes: ["pouces"],
                pouce_up: ["material-icons pouce-up"],
                pouce_down: ["material-icons pouce-down"]
            };
        },
        computed: {},
        mounted() {
            //customLogger("state user", this.$store.state.user);
        },
        methods: {
            async submit(note) {
                let save_params = { id: this.user_id, note: note === 1 };
                //customLogger("a", this.user_id);
                if (note === 1 | -1){
                    //customLogger("parici", save_params)
                    this.classes.push("checker_disable")
                    await this.$store.dispatch("SUBMIT_MESSAGE_CHECKER", save_params);
                    if (note === -1) {
                        store_utils.emit_message({
                            message: "chat.apologies",
                            dialogflow: true,
                            commit: true,
                            sender: "bot",
                            typing: true,
                        });
                        this.pouce_down.push("checker_active")
                    } else if (note === 1) {
                        this.pouce_up.push("checker_active")
                    }
                }
            }
        }
    }
</script>